<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<p-messages [(value)]="messages" [enableService]="true"></p-messages>

<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
<app-add-unit
  [currentParent]="currentParent"
  [updateData]="updateData"
  (closeModal)="closeCreateModal($event)"
  *ngIf="showCreateModal"
></app-add-unit>

<app-assign-users
  [selectionData]="updateData?.managers"
  (selectedUsersList)="addManagers($event)"
  [userFetchUrl]="'user'"
  *ngIf="showAddManagers"
></app-assign-users>

<div [hidden]="showCreateModal || showAddManagers">
  <!-- skelition   -->
  <app-skelitions [hidden]="!skelition" [value]="2"></app-skelitions>
  <app-no-data *ngIf="data.length == 0 && !skelition"></app-no-data>
  <div class="row w-100 m-0 v4-bg-img" *ngIf="data.length > 0 && !skelition">
    <div
      class="col-lg-6 container-fluid justify-content-center py-4"
      style="min-height: 60vh"
      dir="rtl"
    >
      <div class="d-flex justify-content-center">
        <p-tree
          class="w-full md-w-30rem-custom ppp-p-tree custom-tree"
          [filter]="true"
          [filterBy]="'label'"
          filterPlaceholder="{{ 'Search filter' | translator }}"
          [value]="treeDDData"
          selectionMode="single"
          (onNodeSelect)="selectedTab($event)"
          droppableScope="self"
          styleClass="w-100"
        >
          <ng-template let-node pTemplate="default">
            <div
              class="{{
                node.active == false ? 'inactive-bg' : ''
              }} d-flex show-button w-100 align-items-center"
              [ngClass]="
                this.selectedid && this.selectedid == node ? 'selectedNode' : ''
              "
              *ngIf="node != undefined"
            >
              <img
                *ngIf="checkisImg(node.data); else elseBlock"
                src="{{ staticURL }}{{ node.data }}"
                class="img-fluid p-1 tree-img-bg"
                style="
                  height: 30px;
                  width: 30px;
                  background: white;
                  border-radius: 6px;
                  margin-left: 5px;
                "
              />
              <ng-template #elseBlock>
                <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
              </ng-template>
              <b class="text-nowrap">{{ node.label }} </b>
              <p-button
                class="mx-1 hide-button"
                [pTooltip]="'Edit' | translator"
                *ngIf="
                  node.id &&
                  updatePermission &&
                  checkPermission(allowdOusToUpdateIn, node) &&
                  checkTagPermission(allowedUpdateTag, 'Ministries/Entities')
                "
                (click)="
                  actionCall({ action: 'Update', id: node._id, tree: true })
                "
                icon="pi pi-file-edit"
                styleClass="p-button-rounded button-sq-2rem p-button-warning p-button-text p-button-raised"
              ></p-button>
              <p-button
                class="mx-1 hide-button"
                [pTooltip]="'Delete' | translator"
                *ngIf="
                  node.id &&
                  deletePermission &&
                  checkPermission(allowdOusToDeleteIn, node) &&
                  checkTagPermission(allowedDeleteTag, 'Ministries/Entities')
                "
                (click)="
                  actionCall({ action: 'Delete', id: node._id, tree: true })
                "
                icon="pi pi-times"
                styleClass="p-button-rounded button-sq-2rem p-button-danger p-button-text p-button-raised"
              ></p-button>

              <p-button
                class="mx-1 hide-button"
                [pTooltip]="'Add Managers' | translator"
                (onClick)="
                  actionCall({
                    action: 'Add Managers',
                    id: node._id,
                    tree: true
                  })
                "
                *ngIf="
                  node.id &&
                  updatePermission &&
                  userManagemenetPermission &&
                  checkPermission(allowdOusToUpdateIn, node) &&
                  checkTagPermission(allowedUpdateTag, 'Ministries/Entities')
                "
                icon="pi pi-user-plus"
                styleClass="p-button-rounded button-sq-2rem p-button-warning p-button-text p-button-raised"
              ></p-button>

              <p-button
                class="mx-1 hide-button"
                [pTooltip]="'Create Type' | translator"
                *ngIf="
                  node.label == 'الجهات المشاركة' &&
                  createPermission &&
                  checkPermission(allowdOusToCreateIn, node)
                "
                (click)="showCreateType = true"
                icon="pi pi-plus"
                styleClass="p-button-rounded button-sq-2rem p-button-success p-button-text p-button-raised"
              ></p-button>

              <p-button
                class="mx-1 hide-button"
                [pTooltip]="'Create Type' | translator"
                *ngIf="
                  node.label != 'الجهات المشاركة' &&
                  createPermission &&
                  checkPermission(allowdOusToCreateIn, node) &&
                  checkTagPermission(allowedCreateTag, 'Ministries/Entities')
                "
                (click)="setupCreateOu(node, 'Ministries/Entities')"
                icon="pi pi-plus"
                styleClass="p-button-rounded button-sq-2rem p-button-success p-button-text p-button-raised"
              ></p-button>

              <span
                class="w-100"
                *ngIf="this.selectedid && this.selectedid == node"
              >
                <i class="pi pi-angle-double-left float-end"></i>
              </span>
            </div>
          </ng-template>
        </p-tree>
      </div>
    </div>
    <div
      *ngIf="
        selectedTreeData_orginal &&
          selectedTreeData_orginal.length > 0 &&
          !loadingSelected;
        else loader
      "
      class="col-lg-6 container-fluid justify-content-center py-4"
      style="min-height: 60vh"
      dir="rtl"
    >
      <div class="d-flex justify-content-center flex-column">
        <h2 class="v4-color-white">
          {{ "the detail" | translator }}
        </h2>
        <p-tabMenu
          class="w-full md-w-30rem-custom v4-custom-manage"
          [scrollable]="false"
          [model]="selectedTreeTags"
          [activeItem]="selectedTreeTags_current"
          (activeItemChange)="changeSelectedTag($event)"
        >
          <ng-template class="v4-custom-manage" pTemplate="item" let-item>
            {{ item.label | translator }}
          </ng-template>
        </p-tabMenu>
        <p-tree
          class="w-full md-w-30rem-custom ppp-p-tree custom-tree"
          [filter]="true"
          [filterBy]="'label'"
          filterPlaceholder="{{ 'Search filter' | translator }}"
          [value]="selectedTreeData"
        >
          <ng-template let-node pTemplate="default">
            <ng-container *ngIf="node">
              <div
                *ngIf="selectedTreeData.indexOf(node) == 0; else childTemplate"
                class="{{
                  node.active == false ? 'inactive-bg' : ''
                }} d-flex show-button align-items-center"
              >
                <img
                  *ngIf="checkisImg(node.data); else elseBlock"
                  src="{{ staticURL }}{{ node.data }}"
                  class="img-fluid p-1 tree-img-bg"
                  style="
                    height: 30px;
                    width: 30px;
                    background: white;
                    border-radius: 6px;
                    margin-left: 5px;
                  "
                />
                <ng-template #elseBlock>
                  <i class="{{ node.data }} m-2" style="font-size: 1rem"></i>
                </ng-template>
                <b class="text-nowrap">{{ node.label }} </b>
                <p-button
                  class="mx-1 hide-button"
                  [pTooltip]="'Create' | translator"
                  *ngIf="
                    node &&
                    selectedTreeTags_current &&
                    selectedTreeTags_current.label &&
                    createPermission &&
                    checkPermission(allowdOusToCreateIn, node) &&
                    checkTagPermission(
                      allowedCreateTag,
                      selectedTreeTags_current
                    )
                  "
                  (click)="
                    setupCreateOu(node, selectedTreeTags_current.label, true)
                  "
                  icon="pi pi-plus"
                  styleClass="p-button-rounded button-sq-2rem p-button-success p-button-text p-button-raised"
                ></p-button>
              </div>
              <ng-template #childTemplate>
                <div
                  class="{{
                    node.active == false ? 'inactive-bg' : ''
                  }} d-flex show-button align-items-center"
                >
                  <img
                    *ngIf="checkisImg(node.data); else elseBlock"
                    src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg"
                    style="
                      max-height: 30px;
                      max-width: 30px;
                      background: white;
                      border-radius: 6px;
                      margin-left: 5px;
                    "
                  />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} m-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }} </b>
                  <p-button
                    class="mx-1 hide-button"
                    [pTooltip]="'Update' | translator"
                    *ngIf="
                      node._id &&
                      updatePermission &&
                      checkPermission(allowdOusToUpdateIn, node) &&
                      checkTagPermission(allowedUpdateTag, node.tag)
                    "
                    (click)="
                      actionCall({ action: 'Update', id: node._id, tree: true })
                    "
                    icon="pi pi-file-edit"
                    styleClass="p-button-rounded button-sq-2rem p-button-warning p-button-text p-button-raised"
                  ></p-button>
                  <p-button
                    class="mx-1 hide-button"
                    [pTooltip]="'Delete' | translator"
                    *ngIf="
                      node._id &&
                      deletePermission &&
                      checkPermission(allowdOusToDeleteIn, node) &&
                      checkTagPermission(allowedDeleteTag, node.tag)
                    "
                    (click)="
                      actionCall({ action: 'Delete', id: node._id, tree: true })
                    "
                    icon="pi pi-times"
                    styleClass="p-button-rounded button-sq-2rem p-button-danger p-button-text p-button-raised"
                  ></p-button>

                  <p-button
                    class="mx-1 hide-button"
                    [pTooltip]="'Add Managers' | translator"
                    *ngIf="
                      node.id &&
                      userManagemenetPermission &&
                      updatePermission &&
                      checkPermission(allowdOusToUpdateIn, node) &&
                      checkTagPermission(allowedUpdateTag, node.tag)
                    "
                    icon="pi pi-user-plus"
                    (onClick)="
                      actionCall({
                        action: 'Add Managers',
                        id: node._id,
                        tree: true
                      })
                    "
                    styleClass="p-button-rounded button-sq-2rem p-button-warning p-button-text p-button-raised"
                  ></p-button>
                  <p-button
                    class="mx-1 hide-button"
                    [pTooltip]="'Create' | translator"
                    *ngIf="
                      node &&
                      selectedTreeTags_current &&
                      selectedTreeTags_current.label &&
                      createPermission &&
                      checkPermission(allowdOusToCreateIn, node) &&
                      checkTagPermission(allowedCreateTag, node.tag)
                    "
                    (click)="
                      setupCreateOu(node, selectedTreeTags_current.label, true)
                    "
                    icon="pi pi-plus"
                    styleClass="p-button-rounded button-sq-2rem p-button-success p-button-text p-button-raised"
                  ></p-button>
                </div>
              </ng-template>
            </ng-container>
          </ng-template>
        </p-tree>
      </div>
    </div>
    <ng-template #loader>
      <div
        *ngIf="loadingSelected"
        class="col-lg-6 container-fluid justify-content-center py-4 align-items-center"
        style="min-height: 60vh"
        dir="rtl"
      >
        <p-progressSpinner
          styleClass="w-4rem h-4rem"
          strokeWidth="4"
          fill="var(--surface-ground)"
          animationDuration="1s"
        ></p-progressSpinner>
      </div>
    </ng-template>
  </div>
</div>

<p-dialog [blockScroll]="true" [draggable]="false" [(visible)]="showCreateType">
  <div class="container mb-5">
    <h2 class="text-center color-ms-purple my-4">
      <i
        style="font-size: 2rem; font-weight: 600"
        class="pi pi-fw pi-plus-circle color-ms-purple"
      ></i>
      {{ "Create a type" | translator }}
    </h2>
    <app-dynamic-form
      [questions]="createtypequestions"
      (sendData)="receiveData($event)"
    ></app-dynamic-form>
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  </div>
</p-dialog>

<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  [(visible)]="showCreateOu"
  [style]="{ width: '50vw' }"
>
  <div class="container mb-5">
    <h2 class="text-center color-ms-purple">
      <i
        style="font-size: 2rem"
        class="pi pi-fw pi-plus-circle mx-2 color-ms-purple"
      ></i>

      {{ "create anything" | translator }} {{ currentTag | translator }}
    </h2>

    <div *ngIf="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <app-dynamic-form
      [questions]="ouQuestions"
      (sendData)="createOuSubmit($event)"
      (imgType)="handleImgTypeChange($event)"
    ></app-dynamic-form>
  </div>
</p-dialog>

<!-- <p-button [label]="'clean'" (onClick)="clean()">

</p-button> -->

<app-footer></app-footer>
